import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { analytics } from '../../../events/segment/analytics';
import { getEmailBaseDomain } from '../../../utils/email-utils';
import { UserService, UserProfile } from '@app/services/api/user/user.service';
import { LoadingSpinnerComponent } from '@app/shared/loading-spinner/loading-spinner.component';
import { SurveyStorageService } from '@app/services/local-storage/survey-storage.service';

@Component({
  selector: 'app-auth-callback',
  imports: [LoadingSpinnerComponent],
  template: `
    <app-loading-spinner></app-loading-spinner>
  `,
  standalone: true
})
export class AuthCallbackComponent {
  constructor(
    @Inject(UserService) private userService: UserService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private surveyStorageService: SurveyStorageService,
  ) { }

  ngOnInit() {
    localStorage.removeItem('user-biq-responses');
    this.surveyStorageService.clearSurveyQuestions();
    this.surveyStorageService.clearUserResponses();

    this.userService.getMe().subscribe({
      next: (userProfile: UserProfile) => {
        try {
          if (isPlatformBrowser(this.platformId)) {
            // Identify user in Segment using userId from /me endpoint
            if (userProfile.userId) {
              analytics.identify(userProfile.userId, {
                email_base_domain: getEmailBaseDomain(userProfile.email),
              });
            }
          }
        } catch (err) {
          console.error('Error identifying user in analytics:', err);
        }

        this.userService.createEmailPreferences({}).subscribe({
          next: () => {
            this.router.navigate(['/career-matches']);
          },
          error: (err) => {
            console.error('Error creating email preferences:', err);
            this.router.navigate(['/career-matches']);
          }
        });
      },
      error: (err) => {
        console.error('Error fetching user profile:', err);

        this.router.navigate(['/career-matches']);
      }
    });
  }
}
